/**
 * The AI tutor ("Luna") agent user id(s). Agent-authored board objects AND the
 * agent's live cursor carry one of these as `userId` (the agent-bridge stamps
 * `AGENT_USER_ID` on every write / cursor event).
 *
 * Kept in its own dependency-free module (no fabric, no board-items imports) so any
 * layer can use it — board rendering (agent-drawon) AND plain services (ai-tutor.service
 * clearing the cursor on disconnect) — without dragging in the canvas stack or risking
 * a circular import.
 *
 * This is the bridge's AGENT_USER_ID (agent-bridge/run-local.sh). If you change it
 * there, change it here too.
 */
export const AGENT_USER_IDS = new Set<string>([
  '6a2fa15727297bf5b82771f2', // agent-bridge AGENT_USER_ID (run-local.sh)
]);
